import Directory from '../../components/directory/Directory';

const Home = () => {
  return <Directory />;
};

export default Home;
